import React, { useState } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import {
  Panel,
  Row,
  Col,
  Message,
  Cascader,
  ControlLabel,
  IconButton,
  Icon,
  Checkbox,
  RadioGroup,
  Radio,
} from 'rsuite'
import NumberFormat from 'react-number-format'
import { useForm, Controller } from 'react-hook-form'
import classNames from 'classnames'
import { startLoading, doneLoading } from '../../../utils/loading'
import { saveBudgetPlan, saveBudgetPlanAtInstallmentStep } from '../../../redux/actions/paymentSave'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import EditButton from '../../../components/buttons/editButton/EditButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import { isValidators, isRequired } from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'

export default function BudgetPlan({
  header,
  isEditable,
  isEdit,
  masterBudgetPlan: _masterBudgetPlan,
  masterBudgetValue: _masterBudgetValue,
  subBudgetPlan: _subBudgetPlan,
  subBudgetValue: _subBudgetValue,
  onComplete,
  projectVersionId,
  limitBudgetValue,
  isSaveBudgetPlanStep,
  skipReserveEbudget,
  setIsEdit = () => {},
  hideSubPlan,
}) {
  const { handleSubmit, errors, control, setValue, watch } = useForm()
  const [isLoading, setIsLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState()
  const [masterBudgetPlan, setMasterBudgetPlan] = useState(_masterBudgetPlan)
  const [masterBudgetValue, setMasterBudgetValue] = useState(_masterBudgetValue)
  const [subBudgetPlan, setSubBudgetPlan] = useState(_subBudgetPlan)
  const [subBudgetValue, setSubBudgetValue] = useState(_subBudgetValue)
  const [oldMasterBudgetValue, setOldMasterBudgetValue] = useState(_masterBudgetValue?.value || 0)
  const [oldSubBudgetValue, setOldSubBudgetValue] = useState(_subBudgetValue?.value || 0)
  const [isSubBudgetPlan, setIsSubBudgetPlan] = useState(
    _subBudgetPlan?.value || _subBudgetValue?.value ? true : false
  )
  const [skipReserveEbudgetValue, setSkipReserveEbudgetValue] = useState(skipReserveEbudget ? 1 : 0)

  const watchMasterBudgetPlan = watch('masterBudgetPlan', masterBudgetPlan?.value)
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const handleSaveBudgetPlan = async (request) => {
    startLoading()
    setIsLoading(true)
    setErrorMessage(null)
    try {
      let _schema
      if (isSaveBudgetPlanStep) {
        _schema = await saveBudgetPlan(request)
      } else {
        _schema = await saveBudgetPlanAtInstallmentStep(request, request.projectVersionId)
      }
      setMasterBudgetPlan((s) => {
        return {
          ...s,
          value: _schema.model.forms.ProjectBudgetPlan?.masterBudgetPlan?.value,
          text: _schema.model.forms.ProjectBudgetPlan?.masterBudgetPlan?.text,
        }
      })
      setMasterBudgetValue((s) => {
        return {
          ...s,
          value: _schema.model.forms.ProjectBudgetPlan?.masterBudgetValue?.value,
        }
      })
      setSubBudgetPlan((s) => {
        return {
          ...s,
          value: _schema.model.forms.ProjectBudgetPlan?.subBudgetPlan?.value,
          text: _schema.model.forms.ProjectBudgetPlan?.subBudgetPlan?.text,
        }
      })
      setSubBudgetValue((s) => {
        return {
          ...s,
          value: _schema.model.forms.ProjectBudgetPlan?.subBudgetValue?.value,
        }
      })

      setOldMasterBudgetValue(_schema.model.forms.ProjectBudgetPlan?.masterBudgetValue?.value)
      setOldSubBudgetValue(_schema.model.forms.ProjectBudgetPlan?.subBudgetValue?.value)

      if (typeof onComplete === 'function') {
        onComplete(_schema?.model?.forms)
      }
    } catch (e) {
      setErrorMessage('เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ')
    }
    setIsEdit(false)
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    // console.log('data => ', data)
    // if (limitBudgetValue != null && limitBudgetValue != undefined) {
    //   const _masterBudgetValue = data.masterBudgetValue ? parseFloat(data.masterBudgetValue) : 0
    //   const _subBudgetValue = data.subBudgetValue ? parseFloat(data.subBudgetValue) : 0
    //   const total = _masterBudgetValue + _subBudgetValue
    //   if (limitBudgetValue !== total) {
    //     setErrorMessage('กรุณากรอกงบประมาณให้ถูกต้อง')
    //     return
    //   }
    // }

    const request = {
      projectVersionId: projectVersionId || projectId,
      masterBudgetPlanValue: data.masterBudgetPlan,
      masterBudgetValue: data.masterBudgetValue,
      subBudgetPlanValue: data.subBudgetPlan,
      subBudgetValue: data.subBudgetValue,
      skipReserveEbudget: data.skipReserveEbudget,
    }
    // console.log('request => ', request)
    handleSaveBudgetPlan(request)
  }

  const onCancel = () => {
    // if (limitBudgetValue != null && limitBudgetValue != undefined) {
    //   const total = oldMasterBudgetValue + oldSubBudgetValue
    //   if (limitBudgetValue !== total) {
    //     setErrorMessage('กรุณาแก้ไขงบประมาณให้ถูกต้อง')
    //     return
    //   }
    // }
    setIsSubBudgetPlan(subBudgetPlan?.value || subBudgetPlan?.value ? true : false)
    setIsEdit(false)
    setErrorMessage(null)
  }

  const getSubBudgetDefaultValue = () => {
    if (subBudgetValue?.value) {
      return subBudgetValue?.value
    }
    return 0
    // if (!limitBudgetValue) {
    //   return ''
    // }
    // if (masterBudgetValue?.value) {
    //   return limitBudgetValue - masterBudgetValue?.value
    // }

    // return limitBudgetValue / 2
  }

  const getBudgetSummaryValue = (masterBudgetValue?.value || 0) + (subBudgetValue?.value || 0)

  return (
    <Panel header={header} bordered collapsible defaultExpanded>
      {!isSaveBudgetPlanStep && (
        <>
          <h5
            style={{ color: '#2da888' }}
          >{`งบประมาณโครงการที่ขออนุมัติ ${getBudgetSummaryValue.toLocaleString()} บาท`}</h5>
          <br />
        </>
      )}
      <div>
        {!isEdit ? (
          <>
            <p style={{ fontWeight: 'bold' }}>{masterBudgetPlan?.label}</p>
            <p>{masterBudgetPlan?.text || '-'}</p>
            <p>{`${masterBudgetValue?.label || ''} ${(
              masterBudgetValue?.value || 0
            ).toLocaleString()} บาท`}</p>
          </>
        ) : (
          <Row>
            <Col xs={24} sm={24} md={24} lg={24}>
              <ControlLabel
                style={{ fontWeight: 'bold' }}
                className={classNames(isRequired(masterBudgetPlan?.validators) && 'required')}
              >
                {masterBudgetPlan?.label}
              </ControlLabel>
              <ErrorMessage error={errors.masterBudgetPlan} />
              <Controller
                name={'masterBudgetPlan'}
                control={control}
                defaultValue={masterBudgetPlan.value}
                rules={isValidators(masterBudgetPlan.validators)}
                render={(props) => {
                  return (
                    <Cascader
                      size="lg"
                      block
                      menuWidth={220}
                      data={masterBudgetPlan.items}
                      value={props.value}
                      onChange={(value) => {
                        props.onChange(value)
                        setValue('subBudgetPlan', null)
                      }}
                      placeholder={masterBudgetPlan?.label}
                    ></Cascader>
                  )
                }}
              />
            </Col>
            <Col xs={24} sm={24} md={12} lg={8} style={{ marginTop: '10px' }}>
              <ErrorMessage error={errors.masterBudgetValue} />
              <ControlLabel
                className={classNames(isRequired(masterBudgetValue?.validators) && 'required')}
              >
                {masterBudgetValue?.label}
              </ControlLabel>
              <Controller
                name={'masterBudgetValue'}
                control={control}
                defaultValue={masterBudgetValue?.value || limitBudgetValue || ''}
                rules={isValidators(masterBudgetValue?.validators)}
                render={(props) => {
                  return (
                    <NumberFormat
                      className="rs-input"
                      placeholder={masterBudgetValue?.label}
                      thousandSeparator={true}
                      value={props.value}
                      onValueChange={(value) => {
                        props.onChange(value.floatValue)
                      }}
                    />
                  )
                }}
              />
            </Col>
            {!hideSubPlan && (
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={24}
                style={{ marginTop: '20px', marginBottom: isSubBudgetPlan ? 0 : 40 }}
              >
                <IconButton
                  appearance="ghost"
                  className={isSubBudgetPlan ? 'rs-btn-ghost-cancel' : ''}
                  onClick={() => {
                    setIsSubBudgetPlan(!isSubBudgetPlan)
                  }}
                  icon={
                    <Icon
                      appearance="ghost"
                      icon={isSubBudgetPlan ? 'trash' : 'plus'}
                      className={
                        isSubBudgetPlan ? 'bt-gost-icon-radius-cancel' : 'bt-gost-icon-radius'
                      }
                    />
                  }
                >
                  {isSubBudgetPlan ? 'ลบแผนรอง' : 'ระบุแผนรอง (ถ้ามี)'}
                </IconButton>
              </Col>
            )}

            <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: '10px' }}>
              <Controller
                name={'skipReserveEbudget'}
                control={control}
                defaultValue={skipReserveEbudgetValue}
                // rule={register(isValidators([{ type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอกเลขที่ใบสำคัญ' }]))}
                render={(props) => {
                  return (
                    <RadioGroup
                      inline
                      value={skipReserveEbudgetValue}
                      onChange={(value) => {
                        props.onChange(value)
                        setSkipReserveEbudgetValue(value)
                      }}
                    >
                      {[
                        { label: 'อนุมัติในปีงบประมาณนี้', value: 0, disabled: null },
                        { label: 'อนุมัติในปีงบประมาณถัดไป', value: 1, disabled: null },
                      ].map((item) => (
                        <Radio
                          key={item.value}
                          value={item.value}
                          // disabled={schema.reviewerFilter.disabled || disabledForm}
                        >
                          <p style={{ marginTop: -1 }}>{item.label}</p>
                        </Radio>
                      ))}
                    </RadioGroup>
                  )
                }}
              />
              {/* <Checkbox
                defaultChecked={skipReserveEbudgetValue}
                onChange={(_, checked) => {
                  console.log('value selected ', checked)
                  setSkipReserveEbudgetValue(checked)
                }}
              >
                {' '}
                <p style={{ marginTop: -3 }}>ยังไม่ต้องจองงบประมาณตามแผนที่เลือก</p>
              </Checkbox> */}
            </Col>
          </Row>
        )}
      </div>

      {!hideSubPlan && isSubBudgetPlan && (
        <div style={{ marginTop: 40, marginBottom: 40 }}>
          {!isEdit ? (
            <>
              <p style={{ fontWeight: 'bold' }}>{subBudgetPlan?.label}</p>
              <p>{subBudgetPlan?.text || '-'}</p>
              <p>{`${subBudgetValue?.label || ''} ${(
                subBudgetValue?.value || 0
              ).toLocaleString()} บาท`}</p>
            </>
          ) : (
            <Row>
              <Col xs={24} sm={24} md={24} lg={24}>
                <ControlLabel style={{ fontWeight: 'bold' }}>{subBudgetPlan?.label}</ControlLabel>
                <Controller
                  name={'subBudgetPlan'}
                  control={control}
                  defaultValue={subBudgetPlan.value}
                  render={(props) => {
                    return (
                      <Cascader
                        size="lg"
                        block
                        menuWidth={220}
                        data={subBudgetPlan.items}
                        value={props.value}
                        onChange={(value) => {
                          props.onChange(value)
                        }}
                        placeholder={subBudgetPlan?.label}
                        disabledItemValues={[watchMasterBudgetPlan]}
                        disabled={!watchMasterBudgetPlan}
                      ></Cascader>
                    )
                  }}
                />
              </Col>

              <Col xs={24} sm={24} md={12} lg={8} style={{ marginTop: '10px' }}>
                <ErrorMessage error={errors.subBudgetValue} />
                <ControlLabel
                  className={classNames(isRequired(subBudgetValue?.validators) && 'required')}
                >
                  {subBudgetValue?.label}
                </ControlLabel>
                <Controller
                  name={'subBudgetValue'}
                  control={control}
                  defaultValue={getSubBudgetDefaultValue()}
                  rules={isValidators(subBudgetValue?.validators)}
                  render={(props) => {
                    return (
                      <NumberFormat
                        className="rs-input"
                        placeholder={subBudgetValue?.label}
                        thousandSeparator={true}
                        value={props.value}
                        onValueChange={(value) => {
                          props.onChange(value.floatValue)
                        }}
                      />
                    )
                  }}
                />
              </Col>
            </Row>
          )}
        </div>
      )}

      {!!isEditable && (
        <Col
          style={{ marginBottom: 20, marginTop: isSubBudgetPlan ? 0 : 40, padding: 0 }}
          xs={24}
          sm={24}
          md={24}
          lg={24}
        >
          {isEdit ? (
            <div>
              {!!errorMessage && (
                <div style={{ marginBottom: 10 }}>
                  <Message showIcon type="error" description={errorMessage} />
                </div>
              )}
              <SaveButton onClick={handleSubmit(onSubmit)} disabled={isLoading}></SaveButton>
              <CancelButton onClick={onCancel} disabled={isLoading}></CancelButton>
            </div>
          ) : (
            <EditButton
              onClick={() => {
                setIsEdit(true)
              }}
            >
              แก้ไขแผน
            </EditButton>
          )}
        </Col>
      )}
    </Panel>
  )
}
